

import hSeriesImg from "../assets/images//vehicles/h-series/h-series-blue-trans.png";
import ehSeriesImg from "../assets/images/vehicle-2-card-banner.png";
import dumperImg from "../assets/images/vehicle-3-card-banner.png";

// H-Series IMAGES STARTS

import lkcs5WhiteImage from "../assets/images/vehicles/h-series/h-series-white-trans.png";
import lkcs5RedImage from "../assets/images/vehicles/h-series/h-series-red-trans.png";
import lkcs5BlueImage from "../assets/images/vehicles/h-series/h-series-blue-trans.png";


// H-Series IMAGES ENDS

// H-Series BROCHURE STARTS

import hSeriesBrochure from "../assets/images/vehicles/h-series/brochure/landking-h-series-brochure.pdf"

// H-SERIES BROCHURE ENDS

// VEHICLE INTRO BANNER STARTS

import lkCS5Banner from "../assets/images/h-series-mark-banner.png";

// VEHICLE INTRO BANNER ENDS

// VEHICLE FEATURES IMAGE STARTS


import hSeriesFeature1 from "../assets/images/vehicles/h-series/features/feature-1.png";
import hSeriesFeature2 from "../assets/images/vehicles/h-series/features/features-2.png";
import hSeriesFeature3 from "../assets/images/vehicles/h-series/features/feature-3.png";
import hSeriesFeature4 from "../assets/images/vehicles/h-series/features/feature-4.png";
import hSeriesFeature5 from "../assets/images/vehicles/h-series/features/features-5.png"

// VEHICLE FEATURES IMAGE ENDS


// VEHICLE TECH SECTION STARTS

import hSeriesTech1 from "../assets/images/vehicles/h-series/technology/technology-1.png";
import hSeriesTech2 from "../assets/images/vehicles/h-series/technology/technology-2.png";


// VEHICLE TECH SECTION ENDS// 


// VEHICLE INTERIOR SECTION STARTS //

import hSeriesInterior1 from "../assets/images/vehicles/h-series/interiors/interiors-1.png";
import hSeriesInterior2 from "../assets/images/vehicles/h-series/interiors/interiors-2.png";
import hSeriesInterior3 from "../assets/images/vehicles/h-series/interiors/interiors-3.png";
import hSeriesInterior4 from "../assets/images/vehicles/h-series/interiors/interiors-4.png";
import hSeriesInterior5 from "../assets/images/vehicles/h-series/interiors/interiors-5.png";
import hSeriesInterior6 from "../assets/images/vehicles/h-series/interiors/interiors-6.png";


// VEHICLE INTERIOR SECTION ENDS //

const vehiclesData = [
  {
    id: "veh-h-series",
    brandKey: "vehicles.hSeries.brand",
    modelNameKey: "vehicles.hSeries.modelName",
    titleKey: "vehicles.hSeries.title",
    imageSrc: hSeriesImg,
    href: "/vehicles/h-series",
    background: "#1E8BCB",
    shortDescriptionKey: "vehicles.hSeries.shortDescription",
    price: "SAR 79,800",
    engine: "2.3L - 3.0L",
    payload: "4TONS - 6TONS",
    hpTorque: "320 HP / 1,250 Nm",
    detailIntroBanner: lkCS5Banner,
    detailIntroTitleKey: "vehicles.hSeries.detailIntro.title",
    detailIntroParagraph1Key: "vehicles.hSeries.detailIntro.p1",
    detailIntroParagraph2Key: "vehicles.hSeries.detailIntro.p2",
    variants: [
      {
        id: "h60s",
        name: "H-60S",
        priceLabel: "SAR 79,800*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "140 HP / 320 Nm",
        payload: "4005KG",
        engine: "2.3L"
      },
      {
        id: "h60l",
        name: "H-60L",
        priceLabel: "SAR 81,800*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "140 HP / 320 Nm",
        payload: "4005KG",
        engine: "2.3L"
      },
      {
        id: "h75s",
        name: "H-75S",
        priceLabel: "SAR 89,800*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "160 HP / 480 Nm",
        payload: "5100KG",
        engine: "3.0L"
      },
      {
        id: "h75L",
        name: "H-75L",
        priceLabel: "SAR 91,800*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "160 HP / 480 Nm",
        payload: "5100KG",
        engine: "3.0L"
      },
      {
        id: "h95s",
        name: "H-95S",
        priceLabel: "SAR 102,800*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "160 HP / 480 Nm",
        payload: "6550KG",
        engine: "3.0L"
      },
      {
        id: "h95l",
        name: "H-95L",
        priceLabel: "SAR 104,800*",
        brochureUrl: hSeriesBrochure,
        hpTorque: "160 HP / 480 Nm",
        payload: "6500KG",
        engine: "3.0L"
      }
    ],

    colors: [
      {
        id: "blue",
        name: "Midnight Blue",
        colorCode: "#637DA8",
        imageSrc: lkcs5BlueImage
      },
      {
        id: "white",
        name: "Arctic White",
        colorCode: "#FFFFFF",
        imageSrc: lkcs5WhiteImage
      },
      {
        id: "red",
        name: "Crimson Red",
        colorCode: "#b12028",
        imageSrc: lkcs5RedImage
      },
    ],

    featureSlides: [
      {
        id: "hSerires-power",
        imageSrc: hSeriesFeature1,
        titleKey: "vehicles.hSeries.features.slide1.title",
        descriptionKey:
          "vehicles.hSeries.features.slide1.desc",
      },
      {
        id: "hSeries-Feature-2",
        imageSrc: hSeriesFeature2,
        titleKey: "vehicles.hSeries.features.slide2.title",
        descriptionKey:
          "vehicles.hSeries.features.slide2.desc",
      },
      {
        id: "hSeries-Feature-3",
        imageSrc: hSeriesFeature3,
        titleKey: "vehicles.hSeries.features.slide3.title",
        descriptionKey:
          "vehicles.hSeries.features.slide3.desc",
      },
      {
        id: "hSeries-Feature-4",
        imageSrc: hSeriesFeature4,
        titleKey: "vehicles.hSeries.features.slide4.title",
        descriptionKey:
          "vehicles.hSeries.features.slide4.desc",
      },
      {
        id: "hSeries-Feature-5",
        imageSrc: hSeriesFeature5,
        titleKey: "vehicles.hSeries.features.slide5.title",
        descriptionKey:
          "vehicles.hSeries.features.slide5.desc",
      }
    ],

    technologySlides: [
      {
        id: "hSeries-tech-1",
        titleKey: "vehicles.hSeries.technology.slide1.title",
        paragraph1Key: "vehicles.hSeries.technology.slide1.p1",
        paragraph2Key: "vehicles.hSeries.technology.slide1.p2",
        imageSrc: hSeriesTech1
      },
      {
        id: "hSeries-tech-2",
        titleKey: "vehicles.hSeries.technology.slide2.title",
        paragraph1Key: "vehicles.hSeries.technology.slide2.p1",
        paragraph2Key: "vehicles.hSeries.technology.slide2.p2",
        imageSrc: hSeriesTech2
      }
    ],

    interiors: [
      {
        id: "hSeries-int-1",
        imageSrc: hSeriesInterior1,
        titleKey: "vehicles.hSeries.interiors.item1.title",
        descriptionKey: "vehicles.hSeries.interiors.item1.desc"
      },
      {
        id: "hSeries-int-2",
        imageSrc: hSeriesInterior2,
        titleKey: "vehicles.hSeries.interiors.item2.title",
        descriptionKey: "vehicles.hSeries.interiors.item2.desc"
      },
      {
        id: "hSeries-int-3",
        imageSrc: hSeriesInterior3,
        titleKey: "vehicles.hSeries.interiors.item3.title",
        descriptionKey: "vehicles.hSeries.interiors.item3.desc"
      },
      {
        id: "hSeries-int-4",
        imageSrc: hSeriesInterior4,
        titleKey: "vehicles.hSeries.interiors.item4.title",
        descriptionKey: "vehicles.hSeries.interiors.item4.desc"
      },
      {
        id: "hSeries-int-5",
        imageSrc: hSeriesInterior5,
        titleKey: "vehicles.hSeries.interiors.item5.title",
        descriptionKey: "vehicles.hSeries.interiors.item5.desc"
      },
      {
        id: "hSeries-int-6",
        imageSrc: hSeriesInterior6,
        titleKey: "vehicles.hSeries.interiors.item6.title",
        descriptionKey: "vehicles.hSeries.interiors.item6.desc"
      }
    ],

    spareParts: [
      {
        variantId: "h-60-SpareParts",
        variantName: "H60",
        parts: [
          {
            id: "hSeries-std-part-1",
            descriptionEn: "Engine Oil (per liter)",
            price: "SAR 21.85",
            descriptionAr: "زيت محرك (لكل لتر)"
          },
          {
            id: "hSeries-std-part-2",
            descriptionEn: "Engine Oil Filter",
            price: "SAR 78.20",
            descriptionAr: "فلتر زيت المحرك"
          },
          {
            id: "hSeries-std-part-3",
            descriptionEn: "Fuel Filter",
            price: "SAR 89.70",
            descriptionAr: "فلتر الوقود"
          },
          {
            id: "hSeries-std-part-4",
            descriptionEn: "Air Filter",
            price: "SAR 224.25",
            descriptionAr: "فلتر الهواء"
          },
          {
            id: "hSeries-std-part-5",
            descriptionEn: "Brake Shoe Front",
            price: "SAR 458.85",
            descriptionAr: "فحمات فرامل أمامية"
          },
          {
            id: "hSeries-std-part-6",
            descriptionEn: "Brake Shoe Rear",
            price: "SAR 548.55",
            descriptionAr: "فحمات فرامل خلفية"
          }
        ]
      },
      {
        variantId: "h-75-SpareParts",
        variantName: "H75",
        parts: [
          {
            id: "hSeries-std-part-1",
            descriptionEn: "Engine Oil (per liter)",
            price: "SAR 21.85",
            descriptionAr: "زيت محرك (لكل لتر)"
          },
          {
            id: "hSeries-std-part-2",
            descriptionEn: "Engine Oil Filter",
            price: "SAR 78.20",
            descriptionAr: "فلتر زيت المحرك"
          },
          {
            id: "hSeries-std-part-3",
            descriptionEn: "Fuel Filter",
            price: "SAR 166.75",
            descriptionAr: "فلتر الوقود"
          },
          {
            id: "hSeries-std-part-4",
            descriptionEn: "Air Filter",
            price: "SAR 224.25",
            descriptionAr: "فلتر الهواء"
          },
          {
            id: "hSeries-std-part-5",
            descriptionEn: "Brake Shoe Front",
            price: "SAR 458.85",
            descriptionAr: "فحمات فرامل أمامية"
          },
          {
            id: "hSeries-std-part-6",
            descriptionEn: "Brake Shoe Rear",
            price: "SAR 548.55",
            descriptionAr: "فحمات فرامل خلفية"
          }
        ]
      },
      {
        variantId: "h-95-SpareParts",
        variantName: "H95",
        parts: [
          {
            id: "hSeries-std-part-1",
            descriptionEn: "Engine Oil (per liter)",
            price: "SAR 21.85",
            descriptionAr: "زيت محرك (لكل لتر)"
          },
          {
            id: "hSeries-std-part-2",
            descriptionEn: "Engine Oil Filter",
            price: "SAR 78.20",
            descriptionAr: "فلتر زيت المحرك"
          },
          {
            id: "hSeries-std-part-3",
            descriptionEn: "Fuel Filter",
            price: "SAR 166.75",
            descriptionAr: "فلتر الوقود"
          },
          {
            id: "hSeries-std-part-4",
            descriptionEn: "Air Filter",
            price: "SAR 224.25",
            descriptionAr: "فلتر الهواء"
          },
          {
            id: "hSeries-std-part-5",
            descriptionEn: "Brake Shoe Front",
            price: "SAR 458.85",
            descriptionAr: "فحمات فرامل أمامية"
          },
          {
            id: "hSeries-std-part-6",
            descriptionEn: "Brake Shoe Rear",
            price: "SAR 548.55",
            descriptionAr: "فحمات فرامل خلفية"
          }
        ]
      }
    ],

    specVariants: [
      { id: "h60s", nameKey: "vehicles.hSeries.variants.h60s" },
      { id: "h60l", nameKey: "vehicles.hSeries.variants.h60l" },
      { id: "h75s", nameKey: "vehicles.hSeries.variants.h75s" },
      { id: "h75l", nameKey: "vehicles.hSeries.variants.h75l" },
      { id: "h95s", nameKey: "vehicles.hSeries.variants.h95s" },
      { id: "h95l", nameKey: "vehicles.hSeries.variants.h95l" }
    ],

    specifications: [
      {
        id: "dimensions",
        titleKey: "vehicles.hSeries.specs.categories.dimensions",
        rows: [
          {
            labelKey: "vehicles.hSeries.specs.labels.wheelbaseMm",
            values: { h60s: "3300", h60l: "3800", h75s: "3800", h75l: "4200", h95s: "4200", h95l: "4500" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.overallDimensionsMm",
            values: { h60s: "6125*2145*2310", h60l: "6780*2145*2330", h75s: "6780*2150*2330", h75l: "7425*2145*2330", h95s: "7395*2185*2340", h95l: "7887*2185*2340" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.overallLengthOal",
            values: { h60s: "6125", h60l: "6780", h75s: "6780", h75l: "7425", h95s: "7395", h95l: "7887" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.frontOverhangFoh",
            values: { h60s: "1130", h60l: "1130", h75s: "1130", h75l: "1130", h95s: "1130", h95l: "1130" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.rearOverhangRoh",
            values: { h60s: "1695", h60l: "1850", h75s: "1755", h75l: "2005", h95s: "1975", h95l: "2257" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.cableToAxleCa",
            values: { h60s: "2765", h60l: "3265", h75s: "3265", h75l: "3665", h95s: "3665", h95l: "3965" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.cableToEndCe",
            values: { h60s: "4460", h60l: "5020", h75s: "5020", h75l: "5670", h95s: "5670", h95l: "6130" }
          }
        ]
      },
      {
        id: "weight-capacity",
        titleKey: "vehicles.hSeries.specs.categories.weightCapacity",
        rows: [
          {
            labelKey: "vehicles.hSeries.specs.labels.gvwKg",
            values: { h60s: "6500", h60l: "6500", h75s: "8000", h75l: "8000", h95s: "9500", h95l: "9500" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.curbWeightKg",
            values: { h60s: "2180", h60l: "2180", h75s: "2600", h75l: "2600", h95s: "3100", h95l: "3100" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.payloadKg",
            values: { h60s: "4005", h60l: "4005", h75s: "5100", h75l: "5100", h95s: "6550", h95l: "6500" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.fuelTankCapacity",
            values: { h60s: "150L", h60l: "150L", h75s: "200L", h75l: "200L", h95s: "200L", h95l: "200L" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.fuelTankMaterial",
            values: { h60s: "Aluminium Alloy", h60l: "Aluminium Alloy", h75s: "Aluminium Alloy", h75l: "Aluminium Alloy", h95s: "Aluminium Alloy", h95l: "Aluminium Alloy" }
          }
        ]
      },
      {
        id: "powertrain",
        titleKey: "vehicles.hSeries.specs.categories.powertrain",
        rows: [
          {
            labelKey: "vehicles.hSeries.specs.labels.brandModel",
            values: { h60s: "WP2.3Q140E50", h60l: "WP2.3Q140E50", h75s: "WP3NQ160E50", h75l: "WP3NQ160E50", h95s: "WP3NQ160E50", h95l: "WP3NQ160E50" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.ratedPower",
            values: { h60s: "C6J40T-B", h60l: "C6J40T-B", h75s: "C6J50T", h75l: "C6J50T", h95s: "C6J50T", h95l: "C6J50T" }
          }
        ]
      },
      {
        id: "axle-system",
        titleKey: "vehicles.hSeries.specs.categories.axleSystem",
        rows: [
          {
            labelKey: "vehicles.hSeries.specs.labels.frontAxle",
            values: {
              h60s: "3.0T HanDe Maintenance-Free Front Axle",
              h60l: "3.0T HanDe Maintenance-Free Front Axle",
              h75s: "3.0T HanDe Maintenance-Free Front Axle",
              h75l: "3.0T HanDe Maintenance-Free Front Axle",
              h95s: "3.0T HanDe Maintenance-Free Front Axle",
              h95l: "3.0T HanDe Maintenance-Free Front Axle"
            }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.rearAxle",
            values: {
              h60s: "Rated Load 5.0T/4.875 Hande Rear Axle",
              h60l: "Rated Load 5.0T/4.875 Hande Rear Axle",
              h75s: "5T/4.333 Hande Rear Axle",
              h75l: "5T/4.333 Hande Rear Axle",
              h95s: "Rated Load 6T/4.333 Hande Rear Axle",
              h95l: "Rated Load 6T/4.333 Hande Rear Axle"
            }
          }
        ]
      },
      {
        id: "frame-chassis",
        titleKey: "vehicles.hSeries.specs.categories.frameChassis",
        rows: [
          {
            labelKey: "vehicles.hSeries.specs.labels.frameDimensions",
            values: { h60s: "180/800", h60l: "180/800", h75s: "215/800", h75l: "215/800", h95s: "215/800", h95l: "215/800" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.suspensionType",
            values: { h60s: "3/5+2", h60l: "3/5+2", h75s: "3/8+6", h75l: "3/8+6", h95s: "3/8+6", h95l: "3/8+6" }
          }
        ]
      },
      {
        id: "wheels-brakes",
        titleKey: "vehicles.hSeries.specs.categories.wheelsBrakes",
        rows: [
          {
            labelKey: "vehicles.hSeries.specs.labels.tyreType",
            values: { h60s: "215/75R17.5 16PR", h60l: "215/75R17.5 16PR", h75s: "215/75R17.5 16PR", h75l: "215/75R17.5 16PR", h95s: "215/75R17.5 16PR", h95l: "215/75R17.5 16PR" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.spareTyre",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.serviceBrakeType",
            values: { h60s: "Pneumatic Brake", h60l: "Pneumatic Brake", h75s: "Pneumatic Brake", h75l: "Pneumatic Brake", h95s: "Pneumatic Brake", h95l: "Pneumatic Brake" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.absAebEsc",
            values: { h60s: "ABS+ASR", h60l: "ABS+ASR", h75s: "ABS+ASR", h75l: "ABS+ASR", h95s: "ABS+ASR", h95l: "ABS+ASR" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.exhaustAuxBrake",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          }
        ]
      },
      {
        id: "interior-features",
        titleKey: "vehicles.hSeries.specs.categories.interiorFeatures",
        rows: [
          {
            labelKey: "vehicles.hSeries.specs.labels.airConditioner",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.airHorns",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.multimediaSystem",
            values: { h60s: "MP5+Reversing Image", h60l: "MP5+Reversing Image", h75s: "MP5+Reversing Image", h75l: "MP5+Reversing Image", h95s: "MP5+Reversing Image", h95l: "MP5+Reversing Image" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.steeringWheel",
            values: {
              h60s: "Multifunction Steering Wheel with Cruise Control",
              h60l: "Multifunction Steering Wheel with Cruise Control",
              h75s: "Multifunction Steering Wheel with Cruise Control",
              h75l: "Multifunction Steering Wheel with Cruise Control",
              h95s: "Multifunction Steering Wheel with Cruise Control",
              h95l: "Multifunction Steering Wheel with Cruise Control"
            }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.centralLock",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.rearViewMirror",
            values: {
              h60s: "Ordinary Rearview Mirror",
              h60l: "Ordinary Rearview Mirror",
              h75s: "Ordinary Rearview Mirror",
              h75l: "Ordinary Rearview Mirror",
              h95s: "Ordinary Rearview Mirror",
              h95l: "Ordinary Rearview Mirror"
            }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.interiorTrimFinish",
            values: { h60s: "Red & Black", h60l: "Red & Black", h75s: "Red & Black", h75l: "Red & Black", h95s: "Red & Black", h95l: "Red & Black" }
          }
        ]
      },
      {
        id: "exterior-features",
        titleKey: "vehicles.hSeries.specs.categories.exteriorFeatures",
        rows: [
          {
            labelKey: "vehicles.hSeries.specs.labels.headlights",
            values: { h60s: "LED DRLs/LED Headlights", h60l: "LED DRLs/LED Headlights", h75s: "LED DRLs/LED Headlights", h75l: "LED DRLs/LED Headlights", h95s: "LED DRLs/LED Headlights", h95l: "LED DRLs/LED Headlights" }
          },
          {
            labelKey: "vehicles.hSeries.specs.labels.frontFogLights",
            values: { h60s: "Yes", h60l: "Yes", h75s: "Yes", h75l: "Yes", h95s: "Yes", h95l: "Yes" }
          }
        ]
      }
    ],

    servicePackages: {
      variants: ["H60", "H75", "H95"],
      mileageOptions: ["5000km", "20,000km", "40,000km", "60,000km", "80,000km", "100,000km"],

      prices: {
        H60: {
          
          "5000km": "SAR 356.50",
          "20,000km": "SAR 549.70",
          "40,000km": "SAR 946.45",
          "60,000km": "SAR 760.84",
          "80,000km": "SAR 946.45",
          "100,000km": "SAR 933.57"
        },
        H75: {
          
          "5000km": "SAR 367.43",
          "20,000km": "SAR 637.68",
          "40,000km": "SAR 1,518.17",
          "60,000km": "SAR 858.48",
          "80,000km": "SAR 1,518.17",
          "100,000km": "SAR 1,087.33"
        },
        H95: {
          
          "5000km": "SAR 367.43",
          "20,000km": "SAR 637.68",
          "40,000km": "SAR 1,518.17",
          "60,000km": "SAR 858.48",
          "80,000km": "SAR 1,518.17",
          "100,000km": "SAR 1,087.33"
        }
      }
    }
  },

  // {
  //   id: "veh-ev-series",
  //   title: "EH-Series Electric",
  //   imageSrc: ehSeriesImg,
  //   href: "/trucks/eh-series",
  //   background: "#3C2A98",
  //   shortDescription: "While others struggle in city heat and narrow turns, the LK5 laughs in the face of limits. Small in footprint. Giant in attitude.",
  //   price: "SAR 58,000",
  //   engine: "5.0L",
  //   payload: "2.5TONS"
  // },

  // {
  //   id: "veh-dumper",
  //   title: "Heavy Duty Dumper",
  //   imageSrc: dumperImg,
  //   href: "/trucks/dumpers",
  //   background: "#3F3F3F",
  //   shortDescription: "While others struggle in city heat and narrow turns, the LK5 laughs in the face of limits. Small in footprint. Giant in attitude.",
  //   price: "SAR 58,000",
  //   engine: "5.0L",
  //   payload: "2.5TONS"
  // },

  // {
  //   id: "veh-ev-series",
  //   title: "EH-Series Electric",
  //   imageSrc: ehSeriesImg,
  //   href: "/trucks/eh-series",
  //   background: "#3C2A98",
  //   shortDescription: "While others struggle in city heat and narrow turns, the LK5 laughs in the face of limits. Small in footprint. Giant in attitude.",
  //   price: "SAR 58,000",
  //   engine: "5.0L",
  //   payload: "2.5TONS"
  // }
];

export default vehiclesData;
